import React from 'react'
import PropTypes from 'prop-types'

import {FormRadios} from '../../../01-Atoms/FormRadios/FormRadios'


/**
 * SectionBankDetails component
 */
export const StepOne = ({ fieldText, onInputChange, value, validationHash }) => {
  return (
    <div>
      <FormRadios
        name={'account_owner'}
        label={'Account details'}
        value={value}
        required={true}
        validationHash={validationHash}
        onInputChange={onInputChange}
        fieldText={fieldText}
        options={[
          { value: 'y', label: 'Yes' },
          { value: 'n', label: 'No' }
        ]} />
    </div>
  )
}

/**
 * StepOne PropType
 */
StepOne.propTypes = {
  fieldText     : PropTypes.string,
  value         : PropTypes.string,
  validationHash: PropTypes.string,
  onInputChange : PropTypes.func
}
